function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user && user.attributes.token) {
    return { Authorization: "Bearer " + user.attributes.token };
  } else {
    return {};
  }
}

export {
  authHeader,
}